<template>
  <div class="main">
    <div class="select" v-on:click="open" ref="date-picker">
      <div class="textInSelect">
        <div style="color:rgb(119, 119, 119)">{{ getTextTime(selected) }}</div>
        <div class="v-input__append-inner">
          <div class="v-input__icon v-input__icon--append">
            <i aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light primary--text"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="optionDate" v-if="picking" ref="date-picker-content">
      <div class="optionDate_content py-2">
        <div class="text_title disable-selected py-2 px-6" @click="() => onExpanded('day')"><h3>Theo ngày</h3></div>
        <div id="day">
          <TextHover
            class="disable-selected text_content"
            v-on:click="handleDate('today')"
            :isSelect="selected === 'today'"
            text="Hôm nay"
          ></TextHover>
          <TextHover
            class="disable-selected text_content"
            v-on:click="handleDate('3daysAgo')"
            :isSelect="selected === '3daysAgo'"
            text="3 ngày gần đây"
          ></TextHover>
          <TextHover
            class="disable-selected text_content"
            v-on:click="handleDate('7daysAgo')"
            :isSelect="selected === '7daysAgo'"
            text="7 ngày gần đây"
          ></TextHover>
        </div>
        <div class="option">
          <div class="text_title disable-selected py-2 px-6" @click="() => onExpanded('month')">
            <h3>Theo tháng</h3>
          </div>
          <div id="month" :style="{ display: 'none' }">
            <TextHover
              class="disable-selected text_content"
              v-on:click="handleDate('thisMonth')"
              :isSelect="selected === 'thisMonth'"
              text="Tháng hiện tại"
            ></TextHover>
            <TextHover
              class="disable-selected text_content"
              v-on:click="handleDate('lastMonth')"
              :isSelect="selected === 'lastMonth'"
              text="Tháng trước"
            ></TextHover>
          </div>
        </div>
        <div class="option">
          <div class="text_title disable-selected py-2 px-6" @click="() => onExpanded('custom')">
            <h3>Tuỳ chỉnh</h3>
          </div>
          <div id="custom" :style="{ display: 'none' }">
            <div class="customDate option mx-4 my-2">
              <div class="customDate_picker disable-selected">
                <div class="customDate_text">Từ ngày</div>
                <SelectDate @change="val => dateCustomChange(val, 'start')"></SelectDate>
              </div>
              <div>
                <div class="customDate_picker disable-selected">
                  <div class="customDate_text">Đến ngày</div>
                  <SelectDate @change="val => dateCustomChange(val, 'end')"></SelectDate>
                </div>
                <div v-if="error.err" class="mt-2" style="color: red; font-size: 14px">{{ error.message }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-wrap justify-end flex-gap mx-4 py-3" v-if="state === 'custom' && isExpanded">
          <v-btn class="ml-6" dark depressed color="#0D47A1" @click="validate">
            <v-icon left>mdi-filter</v-icon>Áp dụng</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectDate from '../../components/samnec/SelectDate.vue'
import TextHover from '../../components/samnec/TextHover.vue'
const moment = require('moment')

export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      picking: false,
      date: {
        start: '',
        end: ''
      },
      selected: '',
      error: {
        err: false,
        message: ''
      },
      state: 'day',
      isExpanded: false
    }
  },
  components: { SelectDate, TextHover },
  // mounted() {
  //   document.addEventListener('click', this.handleOutsideClick)
  // },
  // beforeDestroy() {
  //   document.removeEventListener('click', this.handleOutsideClick)
  // },
  methods: {
    open() {
      this.picking = !this.picking
      this.resetData()
    },
    resetData() {
      this.date.start = ''
      this.date.end = ''
      this.selected = ''
      this.error.err = false
      this.message = ''
      this.state = 'day'
    },
    dateCustomChange(val, type) {
      this.selected = 'custom'
      if (type === 'start') {
        this.date.start = val
        if (!this.date.end) {
          this.date.end = moment()
            .endOf('day')
            .toISOString()
        }
      }
      if (type === 'end') {
        this.date.end = val
        if (!this.date.start) {
          this.date.start = moment()
            .endOf('day')
            .toISOString()
        }
      }
    },
    handleOutsideClick(event) {
      if (
        !this.$refs['date-picker'].contains(event.target) &&
        !this.$refs['date-picker-content'].contains(event.target)
      ) {
        this.picking = false
      }
    },
    validate() {
      if (this.date.start && this.date.end) {
        const dateString1 = moment(this.date.start)
        const dateString2 = moment(this.date.end)
        if (dateString1.isAfter(dateString2)) {
          this.error.err = true
          this.error.message = 'Ngày cuối cùng phải lớn hơn ngày bắt đầu'
        } else {
          this.picking = false
          this.$emit('changeDate', this.date)
        }
      }
    },
    handleDate(type) {
      switch (type) {
        case 'today':
          this.date.start = moment()
            .startOf('day')
            .toISOString()
          this.date.end = moment()
            .endOf('day')
            .toISOString()
          break
        case '3daysAgo':
          this.date.start = moment()
            .subtract(3, 'days')
            .startOf('day')
            .toISOString()
          this.date.end = moment()
            .endOf('day')
            .toISOString()
          break
        case '7daysAgo':
          this.date.start = moment()
            .subtract(7, 'days')
            .startOf('day')
            .toISOString()
          this.date.end = moment()
            .endOf('day')
            .toISOString()
          break
        case 'thisMonth':
          this.date.start = moment()
            .startOf('month')
            .toISOString()
          this.date.end = moment()
            .endOf('day')
            .toISOString()
          break
        case 'lastMonth':
          this.date.start = moment()
            .subtract(1, 'months')
            .startOf('month')
            .toISOString()
          this.date.end = moment()
            .subtract(1, 'months')
            .endOf('month')
            .toISOString()
          break
        default:
          break
      }
      this.selected = type
      this.validate()
    },
    getTextTime(type) {
      switch (type) {
        case 'today':
          return `Hôm nay (${moment(this.date.end).format('DD/MM/YYYY')})`
        case '3daysAgo':
          return `3 ngày gần đây (Từ ${moment(this.date.start).format('DD/MM/YYYY')} đến ${moment(this.date.end).format(
            'DD/MM/YYYY'
          )})`
        case '7daysAgo':
          return `7 ngày gần đây (Từ ${moment(this.date.start).format('DD/MM/YYYY')} đến ${moment(this.date.end).format(
            'DD/MM/YYYY'
          )})`
        case 'thisMonth':
          return `Tháng hiện tại (Từ ${moment(this.date.start).format('DD/MM/YYYY')} đến ${moment(this.date.end).format(
            'DD/MM/YYYY'
          )})`
        case 'lastMonth':
          return `Tháng trước (Từ ${moment(this.date.start).format('DD/MM/YYYY')} đến ${moment(this.date.end).format(
            'DD/MM/YYYY'
          )})`
        case 'custom':
          return `Tuỳ chọn (Từ ${moment(this.date.start).format('DD/MM/YYYY')} đến ${moment(this.date.end).format(
            'DD/MM/YYYY'
          )})`
        default:
          return this.placeholder || 'Chọn khoảng thời gian'
      }
    },
    onExpanded(id) {
      const ids = ['day', 'month', 'custom']
      ids
        .filter(v => id !== v)
        .map(v => {
          document.getElementById(v).style.display = 'none'
        })
      const el = document.getElementById(id)
      if (this.state === id) {
        const display = el.style.display
        if (display === 'none') {
          el.style.display = 'block'
          this.isExpanded = true
        } else {
          this.isExpanded = false
          el.style.display = 'none'
        }
      } else {
        el.style.display = 'block'
        this.isExpanded = true
        this.state = id
      }
    }
    // handleOutsideClick(event) {
    //   if (
    //     !this.$refs['date-picker'].contains(event.target) &&
    //     !this.$refs['date-picker-content'].contains(event.target)
    //   ) {
    //     this.picking = false
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}
.select {
  width: 100%;
  max-height: 40px;
  border: 1px;
  border-color: #9d9c9c;
  border-style: solid;
  border-radius: 4px;
}
.select:hover {
  cursor: pointer;
}
.textInSelect {
  padding: 6px;
  display: flex;
  justify-content: space-between;
}
.optionDate {
  width: 600px;
  position: absolute;
  background-color: white;
  z-index: 2;
  border: 1px;
  border-color: black;
  border-style: solid;
  border-radius: 5px;
}
.text_title {
  border-radius: 4px;
  color: rgb(156, 156, 156);
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}
.customDate {
  display: flex;
  justify-content: space-between;
}
.customDate_picker {
  display: inline-flex;
  max-width: 260px;
}
.customDate_text {
  white-space: nowrap;
  margin-top: 5px;
  margin-right: 5px;
}
.disable-selected {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.text_content {
  cursor: pointer;
  padding: 8px 48px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}
</style>
